
import { computed, defineComponent } from 'vue';
import { InputElementTypes } from '@/enums';
import TextInputStyleProvider from '@/components/style-providers/TextInputStyleProvider.vue';
import BaseInput from '@/components/form-controls/base/BaseInput.vue';
import Label from '@/components/form-controls/base/Label.vue';
import { NumberProp } from '@/types/shared/number-prop';

export default defineComponent({
  name: 'NumberInput',
  emits: ['update:modelValue', 'blur'],
  components: {
    TextInputStyleProvider,
    BaseInput,
    Label
  },
  props: {
    label: {
      type: String,
      required: true
    },
    modelValue: {
      type: Number
    },
    explanationText: {
      type: String,
      required: true
    }
  },
  setup(props, { emit }) {
    const number = computed({
      get: () => {
        if (props.modelValue && typeof props.modelValue === 'object') {
          return Number((props.modelValue as NumberProp).number);
        }
        return Number(props.modelValue);
      },
      set: value => {
        if (value?.toString().includes('-')) {
          value = 0;
        }
        emit('update:modelValue', Number(value));
      }
    });

    const handleInput = (event: Event) => {
      const input = event.target as HTMLInputElement;
      const newValue = parseFloat(input.value);
      number.value = newValue;
    };

    return {
      number,
      InputElementTypes,
      handleInput
    };
  }
});
